import { Button, ModalNext } from '@instamenu/ui-system-next';
import { captureClientException } from '@instamenu/posthog/client';
import { useEffect, useRef, useState } from 'react';
import type { CameraCaptureAttachment } from './index';

export const CustomCameraCapture = (props: {
  opened: boolean;
  onCapture?: (attachment: CameraCaptureAttachment) => void;
  onClose: () => void;
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [base64Image, setBase64Image] = useState<string | null>(null);

  useEffect(() => {
    let stream: MediaStream | null = null;
    const startCamera = async () => {
      try {
        stream = await navigator.mediaDevices.getUserMedia({ video: true });
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          videoRef.current.play();
        }
      } catch (error) {
        captureClientException(error, {
          source: 'ai-ui.camera-capture.access-camera',
        });
      }
    };

    if (props.opened) startCamera();

    return () => {
      stream?.getTracks().forEach((track) => track.stop());
    };
  }, [props.opened]);

  const captureImage = () => {
    if (videoRef.current) {
      const canvas = document.createElement('canvas');
      canvas.width = videoRef.current.videoWidth;
      canvas.height = videoRef.current.videoHeight;
      const context = canvas.getContext('2d');
      context?.drawImage(videoRef.current, 0, 0);
      const base64 = canvas.toDataURL('image/png');
      setBase64Image(base64);
      console.log(base64);
    }
  };

  const size = 40;

  return (
    <ModalNext opened={props.opened} onRequestClose={props.onClose}>
      <video
        ref={videoRef}
        style={{ width: '100%', maxWidth: '500px', display: base64Image ? 'none' : 'block' }}
      />
      {base64Image && (
        <img src={base64Image} alt="Captured" style={{ maxWidth: '100%', display: 'block' }} />
      )}
      <div style={{ display: 'grid', placeItems: 'center', height: 80, padding: 16 }}>
        {base64Image ? (
          <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', gap: 16 }}>
            <Button onClick={() => setBase64Image(null)} variant="secondary">
              Retake
            </Button>
            <Button
              onClick={() => {
                props.onCapture?.({
                  data: base64Image,
                  mimeType: 'image/png',
                  name: `camera-capture-${Date.now()}.png`,
                });
                props.onClose();
                setBase64Image(null);
              }}
            >
              Use
            </Button>
          </div>
        ) : (
          <button
            style={{
              width: size,
              height: size,
              background: '#ff5555',
              borderRadius: size / 2,
              border: 'none',
              display: 'grid',
              placeItems: 'center',
              margin: 0,
              padding: 0,
              cursor: 'pointer',
            }}
            onClick={captureImage}
          >
            <div
              style={{
                width: size - 6,
                height: size - 6,
                border: '1px solid #fff',
                borderRadius: (size - 6) / 2,
              }}
            ></div>
          </button>
        )}
      </div>
    </ModalNext>
  );
};
